<template>
  <v-app-bar
    app
    :clipped-left="$vuetify.breakpoint.lgAndUp"
    :clipped-right="$vuetify.breakpoint.lgAndUp"
    elevate-on-scroll
    fixed
    :color="$vuetify.theme.dark ? '' : 'white'"
    style="border-bottom: 4px solid #e53935 !important"
  >
    <v-app-bar-nav-icon
      v-if="showDrawerToggle"
      @click.stop="$emit('toggle-drawer')"
      class="mr-2"
    ></v-app-bar-nav-icon>
    <v-img
      src="@/assets/images/navLogo.png"
      max-height="35"
      max-width="35"
      contain
    ></v-img>

    <v-toolbar-title class="ml-0 pl-4">
      <span class="title">Mira One</span>
    </v-toolbar-title>

    <!-- Impersonation Warning Banner -->
    <v-chip
      v-if="impersonationActive"
      color="error"
      text-color="white"
      class="ml-4 font-weight-bold"
      label
      close
      @click:close="stopImpersonation"
    >
      <v-icon left small>mdi-account-switch</v-icon>
      IMPERSONATION: {{ impersonatedUserName }}
    </v-chip>
    <!-- <v-spacer></v-spacer>
    <v-autocomplete
      v-model="select"
      :loading="loading"
      :items="items"
      :search-input.sync="search"
      cache-items
      class="mx-4"
      flat
      hide-no-data
      prepend-inner-icon="mdi-magnify"
      hide-details
      label="Suchen (⌘+K / Strg+K)"
      solo-inverted
      dense
    ></v-autocomplete> -->
    <v-spacer></v-spacer>
    <v-tooltip bottom v-if="showBackToOrgBtn">
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          icon
          v-bind="attrs"
          v-on="on"
          exact
          :to="{ name: 'organization-list' }"
        >
          <v-icon>mdi-office-building</v-icon>
        </v-btn>
      </template>
      <span>Organisationsübersicht</span>
    </v-tooltip>
    <app-bar-support-tools v-if="checkIfSupport"></app-bar-support-tools>
    <!-- <app-bar-organization-switcher></app-bar-organization-switcher> -->
    <!-- <app-bar-notification-center></app-bar-notification-center> -->
    <QRSessionManager />
    <app-bar-user-menu></app-bar-user-menu>
  </v-app-bar>
</template>

<script>
//import AppBarOrganizationSwitcher from "@/components/app-bar/AppBarOrganizationSwitcher.vue";
// import AppBarNotificationCenter from "@/components/app-bar/AppBarNotificationCenter.vue";
import AppBarUserMenu from "@/components/app-bar/AppBarUserMenu.vue";
import AppBarSupportTools from "@/components/app-bar/AppBarSupportTools.vue";
import QRSessionManager from "@/components/qr-login/QRSessionManager.vue";
export default {
  name: "app-bar",
  components: {
    // AppBarOrganizationSwitcher,
    // AppBarNotificationCenter,
    AppBarUserMenu,
    AppBarSupportTools,
    QRSessionManager,
  },
  props: {
    showDrawerToggle: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  data() {
    return {};
  },
  computed: {
    showBackToOrgBtn() {
      let disabledOnPages = [
        "setup-onboarding",
        "organization-list",
        "organization-new",
        "organization-join",
      ];
      if (disabledOnPages.indexOf(this.$route.name) == -1) {
        return true;
      } else {
        return false;
      }
    },
    checkIfSupport() {
      // Check if we have organization context
      // if (this.$store.state.organization && this.$store.state.organization.membership) {
      //   return this.$store.getters["organization/checkIfSupport"];
      // }
      // Fallback for non-organization pages
      return this.$store.getters["user/checkIfSupport"] || false;
    },
    impersonationActive() {
      return this.$store.state.organization?.supportViewAsNormalUser || false;
    },
    impersonatedUserName() {
      return (
        this.$store.state.organization?.impersonatedUserName || "Unbekannt"
      );
    },
  },
  methods: {
    stopImpersonation() {
      // Clear impersonation from sessionStorage
      sessionStorage.removeItem("supportImpersonation");

      // Restore original permissions and clear impersonation state
      this.$store.commit("organization/RESTORE_ORIGINAL_PERMISSIONS");
      this.$store.commit("organization/SET_IMPERSONATED_USER_NAME", null);
      this.$store.commit("organization/SET_SUPPORT_VIEW_AS_NORMAL_USER", false);
    },
  },
};
</script>
